import { selectGroupById } from '@ff-scene-plugins/photo-prints-redux/slices/groupsSlice';
import { actions as photoActions } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpThunk, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import cuid from 'cuid';
import { selectVariantByAttributes } from '../_redux-variants';
import { applyFirstMagicBorderIfFotofun } from '../helpers/applyFirstMagicBorderIfFotofun';
import { addGroup } from './addGroup';
import { applyMagicBorderThunk } from './applyMagicBorderThunk';

export type ChangePhotoVariantMethod = 'copy' | 'move';

export const changePhotoVariant = (
    paperId: string,
    sizeId: string,
    photoId: string,
    method: ChangePhotoVariantMethod,
    forceNewGroup: boolean = false,
    borderId?: string,
    sourceGroupId?: string
): PhotoPrintsPdpThunk => {
    return (dispatch, getState) => {

        const state = getState();
        const variant = selectVariantByAttributes(state, paperId, sizeId, borderId)!;

        const groups = Object.values(state.project.groups.entities);
        const group = groups.find(g => g!.variantId === variant.id);
        const groupId = forceNewGroup || !group
            ? createNewGroup(variant.id, dispatch, sourceGroupId, state)
            : group.id;

        if (method === 'move') {
            dispatch(photoActions.move({ photoId: photoId, groupId: groupId }));
        } else {
            dispatch(photoActions.copy({ photoId: photoId, groupId: groupId }));
        }
    };
};

const createNewGroup = (
    variantId: string,
    dispatch: PhotoPrintsPdpDispatch,
    sourceGroupId?: string,
    state?: PhotoPrintsPdpState
) => {

    const groupId = cuid();

    dispatch(addGroup({
        id: groupId,
        variantId: variantId,
        amountInQueue: 0
    }));

    // Check if we should preserve border from source group
    if (sourceGroupId && state && variantId.includes('fotofun')) {
        const sourceGroup = selectGroupById(state, sourceGroupId);
        if (sourceGroup && (sourceGroup.magicBorderId || sourceGroup.patternId)) {
            // Apply the source group's border instead of default
            const preservedBorderId = sourceGroup.magicBorderId || sourceGroup.patternId;
            if (preservedBorderId) {
                dispatch(applyMagicBorderThunk(groupId, preservedBorderId));
                return groupId; // Skip the default border application
            }
        }
    }

    // Automatically apply first magic border if variant contains "fotofun"
    dispatch(applyFirstMagicBorderIfFotofun(groupId, variantId));

    return groupId;
};